//============================================================================
// Name        : rfid_print_ls_po_items.ts
// Purpose     : Implement Print Lightspeed PO Items
// Created     : 2021-02-24
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import {InitPage} from "../index";
import Cookies from "js-cookie";
declare var client_store_bulk_prints_path: string;

class RfidPrintLsPoItems {

    init() {
        const printLsPoSearchButton     = $("#print_ls_search_btn");
        const printLsPoItemsPrinterId   = $("#print_ls_po_items_printer_id");
        const submitBulkPrint           = $(".submit_bulk_print");
        const submitPrints              = $(".submit_print");
        const searchFieldInput          = $("#search_field_input");

        if (printLsPoItemsPrinterId.val() == "") {
            submitPrints.removeClass("hover-cursor-pointer");
            submitPrints.addClass("hover-cursor-not-allowed disable_link");

            submitBulkPrint.removeClass("hover-cursor-pointer");
            submitBulkPrint.addClass("hover-cursor-not-allowed disable_link");
        }

        printLsPoItemsPrinterId.on("change", (e) => {
            axios.get(`save_selected_printer.json`, { params: { id: $(e.target).val() } });
        });

        printLsPoItemsPrinterId.on("change", (e) => {
            $("input[id=print_job_printer_id]").val($(e.target).val());
            if ($(e.target).val() == "") {
                submitPrints.removeClass("hover-cursor-pointer");
                submitBulkPrint.removeClass("hover-cursor-pointer");

                submitPrints.addClass("disable_link hover-cursor-not-allowed");
                submitBulkPrint.addClass("hover-cursor-not-allowed disable_link");
            } else {
                submitPrints.addClass("hover-cursor-pointer");
                submitBulkPrint.addClass("hover-cursor-pointer");

                submitPrints.removeClass("hover-cursor-not-allowed disable_link");
                submitBulkPrint.removeClass("hover-cursor-not-allowed disable_link");
            }
        });

        $("input:text[id=checkin_qty_cont]").on("change", (e) => {
            (e.target).parentElement.querySelector("#print_job_change_checkin_qty").setAttribute("value", $(e.target).val().toString());
            (e.target).parentElement.parentElement.querySelector(".btn-add-to-ls-inventory").removeAttribute("disabled");
            (e.target).parentElement.parentElement.querySelector(".btn-add-to-ls-inventory").classList.remove("hover-cursor-not-allowed");
            (e.target).parentElement.parentElement.querySelector("#labels_to_print").setAttribute("value", $(e.target).val().toString());
        });

        $("input:text[id=labels_to_print]").on("change", (e) => {
            const oldValueInLabelsToPrint = e.target.getAttribute("value");
            const newValueInLabelsToPrint = parseInt($(e.target).val().toString(), 10);

            const elReceivedQTY = (e.target).parentElement.parentElement.querySelector("#checkin_qty_cont");
            const elReceivedQTYValue = parseInt(elReceivedQTY.getAttribute("value"), 10);

            const elQtyPerLabel = (e.target).parentElement.parentElement.querySelector("#print_job_storage_unit");
            const elQtyPerLabelValue = parseInt(elQtyPerLabel.getAttribute("value"), 10);

            const elForceSaveToInventory = (e.target).parentElement.parentElement.querySelector("#print_job_force_save_to_inventory");

            if (elQtyPerLabelValue != 0) {
                if (elReceivedQTYValue % newValueInLabelsToPrint == 0) {
                    const resultForPerPrint = (elReceivedQTYValue / newValueInLabelsToPrint);
                    elQtyPerLabel.setAttribute("value", resultForPerPrint.toString());
                    // when change 'QTY per Label' column value from default to other value with successfully,
                    // we need to send true value in this param:
                    elForceSaveToInventory.setAttribute("value", "1");
                    // when change 'QTY per Label' column value with successfully,
                    // we need update print job qty with new value:
                    e.target.setAttribute("value", newValueInLabelsToPrint.toString());
                } else {
                    $(e.target).val(oldValueInLabelsToPrint.toString());
                    alert("Your value for Labels to Print is incorrect");
                }
            } else {
                alert("You can not change it, because received qty is zero");
            }
        });

        printLsPoSearchButton.on("click", () => {
            if ($("#search_ls_po").val() != "") {
                $("#loading-dialog").modal("show");
            } else {
                alert("Please, put a PO number at first");
            }
        });
        $(".show_loading").on("click", () => {
            $("#loading-dialog").modal("show");
        });

        $(".btn-print-ls-po-items").on("click", (e) => {
            e.preventDefault();

            const itemNumberField            = (e.target).parentElement.parentElement.querySelector("#print_job_item_number").getAttribute("value");
            const altSerialField             = (e.target).parentElement.parentElement.querySelector("#print_job_alt_serial").getAttribute("value");
            const storageUnitField           = $((e.target).parentElement.parentElement.querySelector("#print_job_storage_unit")).val();
            const tagQtyField                = $((e.target).parentElement.parentElement.querySelector("#labels_to_print")).val();
            const tagQtyCheckinField         = $((e.target).parentElement.parentElement.querySelector("#print_job_change_checkin_qty")).val();
            const tagCopyQtyField            = (e.target).parentElement.parentElement.querySelector("#print_job_copies").getAttribute("value");
            const itemPriceField             = (e.target).parentElement.parentElement.querySelector("#print_job_new_price").getAttribute("value");
            const printerId                  = $(printLsPoItemsPrinterId).val();
            const forceSaveToInventoryField  = (e.target).parentElement.parentElement.querySelector("#print_job_force_save_to_inventory").getAttribute("value");

            let finalQtyField = tagQtyField;
            if (tagQtyCheckinField && (tagQtyField != tagQtyCheckinField)) {
                finalQtyField = tagQtyCheckinField;
            }

            if (tagQtyField == "") {
                alert("Qty cant be blank");
                return;
            } else if (tagQtyField == 0) {
                alert("Qty cant be zero");
                return;
            } else if (itemNumberField == "" || itemNumberField == null) {
                alert("Item number cant be blank");
                return;
            }

            const body = {
                print_job: {
                    qty: finalQtyField,
                    storage_unit: storageUnitField,
                    item_number: itemNumberField,
                    alt_serial: altSerialField,
                    copies: tagCopyQtyField,
                    force_save_to_inventory: forceSaveToInventoryField,
                    new_price: itemPriceField,
                    printer_id: printerId
                }
            };

            $.ajax({
                url: "print",
                type: "post",
                dataType: "json",
                data: body,
                success: this.showSuccess,
                error: ({responseJSON}) => {
                    this.showError(responseJSON.error);
                }
            });
        });

        submitBulkPrint.on("click", (e) => {
            e.preventDefault();
            if (document.getElementById("cont_search_result")) {
                const arrayHeader = ["Asset ID", "Qty to Print"];
                const header = arrayHeader.join(",") + "\n";
                let csvString = header;
                const allRows = (document.querySelector("#tbody_search_cont") as HTMLTableElement).rows;
                const arrayData = [];
                for (let i = 0; i < allRows.length; i++) {
                    const checkInQty = allRows[i].getElementsByTagName("input") as any;
                    const qtyValue = checkInQty.labels_to_print.value;
                    if (qtyValue == "") {
                        alert("Qty cant be blank, please check it.");
                        return;
                    } else if (qtyValue != 0) {
                        arrayData[i] = [
                            parseInt(allRows[i].cells[0].textContent, 10),
                            parseInt(qtyValue, 10)
                        ];
                    }
                }
                if (arrayData.length === 0) {
                    alert("All values are zero in Qty!!");
                    return;
                }

                arrayData.forEach( array => {
                    csvString += array.join(",") + "\n";
                });

                $.ajax({
                    url: "bulk_print",
                    type: "post",
                    dataType: "json",
                    data: { csv_content: csvString },
                    success: () => {
                        window.open(client_store_bulk_prints_path, "_blank").focus();
                    },
                    error: ({responseJSON}) => {
                        this.showError(responseJSON.error);
                    }
                });

            } else {
                alert("Please, search a PO number at first");
            }
        });

        searchFieldInput.on("keyup", (e) => {
            this.tableFilterFunction();
        });
        searchFieldInput.on("change", (e) => {
            this.tableFilterFunction();
        });
    }

    showError(error) {
        $("#error_sentence").text(error);
        $("#error_box").show();

        setTimeout(() => $("#error_box").hide(), 5000);
    }

    showSuccess() {
        $("#success_box").show();
        setTimeout(() => $("#success_box").hide(), 3000);
    }

    tableFilterFunction() {
        // Declare variables
        let input; let filter; let table; let tr; let td; let i; let j;
        input = document.getElementById("search_field_input");
        filter = input.value.toUpperCase();
        table = document.getElementById("filter_table");
        tr = table.getElementsByTagName("tr");

        // Loop through all table rows, and hide those who don't match the search query
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td") ;
            for ( j = 0 ; j < td.length ; j++) {
                const tData = td[j] ;
                if (tData) {
                    if (tData.innerHTML.toUpperCase().indexOf(filter) > -1) {
                        tr[i].style.display = "";
                        break ;
                    } else {
                        tr[i].style.display = "none";
                    }
                }
            }
        }
    }
}

export function LoadPage() {
    InitPage("print_ls_po_items", () => {
        const rfid = new RfidPrintLsPoItems();
        rfid.init();
    });
}
